import { render, staticRenderFns } from "./BannerPictureThumbnailEdit.vue?vue&type=template&id=32ffa0ba&"
import script from "./BannerPictureThumbnailEdit.vue?vue&type=script&lang=js&"
export * from "./BannerPictureThumbnailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports